import React from "react";
import { Settings } from '@mui/icons-material/';

const LoadingChatsPreview = () => {
    return (

        <div className="container-loading-chats-preview" >
            {/*--------Icono de Chat en el color de la paleta-------------- */}
            <Settings className="rotate-icon" sx={{ fontSize: "150px", color: " var(--bg-ligth)" }} />
            {/*------------Contenedor con el texto de seleccionar un chat */}
            <div className="container-loading-chats__text">
                <span style={{ display: "flex", alignItems: "center" }}>
                    Cargando chats... </span>
            </div>
        </div>
    )
};

export default LoadingChatsPreview;